
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M496 488h-24V16a8.007 8.007 0 00-10.87-7.47l-208 80A8.007 8.007 0 00248 96v122.51L45.13 296.53A8.007 8.007 0 0040 304v184H16a8 8 0 000 16h480a8 8 0 000-16zm-248 0H56V309.49l192-73.84zm104 0h-32v-80h32zm48 0h-32v-80h32zm56 0h-40v-88a8 8 0 00-8-8h-96a8 8 0 00-8 8v88h-40V101.49l192-73.84z"}}),_c('path',{attrs:{"d":"M208 328H88a8 8 0 00-8 8v48a8 8 0 008 8h120a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48H96v-32h104zM208 400h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32zM136 400H88a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48H96v-32h32zM424 232h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32zM344 232h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32zM424 304h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32zM344 304h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32zM424 152h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32zM344 152h-48a8 8 0 00-8 8v48a8 8 0 008 8h48a8 8 0 008-8v-48a8 8 0 00-8-8zm-8 48h-32v-32h32z"}})])
          )
        }
      }
    